module.exports = __webpack_public_path__ + "img/transparent-circle.9c8e9239.svg";